import { render, staticRenderFns } from "./PaperStepsModule.vue?vue&type=template&id=2995fe59&scoped=true"
import script from "./PaperStepsModule.vue?vue&type=script&lang=js"
export * from "./PaperStepsModule.vue?vue&type=script&lang=js"
import style0 from "./PaperStepsModule.vue?vue&type=style&index=0&id=2995fe59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995fe59",
  null
  
)

export default component.exports